import { Component, computed, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AppscriptsNumber, AppscriptsNumberCommentIssue } from '../../../../shared/models/appscripts-user.model';
import { AppscriptsUserService } from '../../../../shared/services/appscripts-user.service';

@Component({
  standalone: false,
  selector: 'app-appscripts-user-table-actions',
  templateUrl: './appscripts-user-table-actions.component.html',
  styleUrls: ['./appscripts-user-table-actions.component.scss'],
})
export class AppscriptsUserTableActionsComponent implements ICellRendererAngularComp {
  private currentRow = signal<AppscriptsNumber | null>(null);

  showHasCommentIcon = computed(() => {
    const row = this.currentRow();
    if (!row) return false;

    return (row.comment?.length ?? 0) > 0 || (row.commentIssue && row.commentIssue !== AppscriptsNumberCommentIssue.OTHER);
  });

  constructor(private appscriptsUserService: AppscriptsUserService) {}

  agInit(params: ICellRendererParams): void {
    this.currentRow.set(params.data);
  }

  refresh(params: ICellRendererParams): boolean {
    this.currentRow.set(params.data);
    return true;
  }

  onClick(clickedItem: string) {
    const row = this.currentRow();
    if (!row) return;

    this.appscriptsUserService.announceAction({
      name: clickedItem,
      row,
      column: 'action',
    });
  }
}
